import { useMutation } from '@northladder/services';
import {
  ErrorEventsEnum,
  errorLogToRemoteUtil,
  IApiError,
} from '@northladder/utilities';

import { ILoginUserData } from '../types';
import { USER_ACCOUNTS_API } from '../userAccountsAPIClient';

/**
 * This is to track the type mutation keys in react query cache.
 */
const VERIFY_OTP_MUT = 'verify-otp-mutation-key';

interface IUseLoginTypeOptions {
  onErrorCallback: (error: IApiError) => void;
  onSuccessCallback: (verifyOtpData: ILoginUserData) => void;
}

/**
 * This performs a login type check request.
 */
export const useVerifyOTPMutation = ({
  onSuccessCallback,
  onErrorCallback,
}: IUseLoginTypeOptions) => {
  const { isPending, error, mutate } = useMutation({
    mutationKey: [VERIFY_OTP_MUT],
    networkMode: 'always',
    mutationFn: USER_ACCOUNTS_API.verifyEmailLoginOtp,
    onSuccess: onSuccessCallback,
    onError: (err: IApiError) => {
      errorLogToRemoteUtil({
        error,
        errorCode: ErrorEventsEnum.ERROR_IN_API_CALL,
        errorTitle: 'Error in verifying OTP',
        message: error?.message,
      });

      onErrorCallback(err);

      return err;
    },
  });

  return {
    error,
    isPending,
    verifyOTP: mutate,
  };
};
